/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import tw from "twin.macro";
import styled from "styled-components";

import { ImLocation } from "react-icons/im";
import { GiRotaryPhone, GiEarthAsiaOceania } from "react-icons/gi";
import { MdPhoneIphone, MdEmail } from "react-icons/md";
import CanadaMap from "../Images/canadamap.webp"

const Container = tw.div`md:mx-64 md:mb-28 mb-80 pt-20`;
const TopContainer = tw.div`md:mx-32 mx-4`;

const Header = tw.div`h-90 bg-secondary relative`;
const HeaderContent = tw.div`text-white absolute bottom-0  md:mx-72 mx-10  pb-10 text-4xl`;

const ImageContainer = tw.div``;
const FlexContainer = tw.div`md:flex py-8  md:mx-32 my-12 bg-mapcolor`;
const LeftContainer = tw.div`md:w-6/12 flex justify-center`;
const RightContainer = tw.div`md:w-6/12`;
const FormContainer = tw.div`flex py-4 justify-between `;
const SubmitButtonContainer = tw.div`mt-12 flex justify-center`;

const TitleContainer = tw.div`mx-20 mb-10`;
const DescriptionContainer = tw.div`mx-20`;

const IconContainer = tw.div`mr-4`;
const TabContainer = tw.div`flex my-4 items-center`;

const SectionHeading = tw.h2`text-4xl md:text-5xl text-black text-center  font-playfair tracking-wide`;

const Heading = tw.h2`text-2xl  `;
const SubHeading = tw.div`text-smm my-2 opacity-70 `;
const HeaderHeading = tw.h2`text-3xl  font-playfair`;
const HeaderParagraph = tw.h5`text-smm my-2 w-3/4`;

const SubmitButton = styled.input.attrs({
  type: "submit",
  value: "Submit",
})`
  background: #25283d;
  color: #fff;
  cursor: pointer;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 0;
  text-transform: uppercase;
  height: 35px;
  border-color: transparent;
  box-shadow: 0px;
  outline: none;
  transition: 0.15s;
  text-align: center;
`;

const Input = styled.input`
  font-size: 14px;

  padding-bottom: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid;
  ::placeholder {
    color: palevioletred;
  }
`;

const MessageInput = styled.input`
  font-size: 14px;
  padding-bottom: 10px;
  margin-right: 30px;
  width: 100%;
  resize: none;
  border-bottom: 1px solid;
  ::placeholder {
    color: palevioletred;
  }
`;

export default () => {





  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    alert("Email Sent");
    emailjs.sendForm('service_szw7ju2', 'template_1nph52s', form.current, 'EqbLtGlDc7tzOoxUv')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
  };









  return (
    <>
      <Header>
        <HeaderContent>
          <HeaderHeading>CONTACT US</HeaderHeading>
          <HeaderParagraph>
            SEE BELOW TO HAVE A GREATER UNDERSTANDING OF WHERE SINGH DRYWALL
            STARTED, WHERE WE ARE GOING AND WHAT WE HOLD IMPORTANT TO US AS A
            COMPANY
          </HeaderParagraph>
        </HeaderContent>
      </Header>
      <Container>
        <SectionHeading>GET IN TOUCH</SectionHeading>
        <FlexContainer>
          <LeftContainer>
            <img
              src={CanadaMap}
              width="70%"
            />
          </LeftContainer>

          <RightContainer>
            <TitleContainer>
              <Heading>Contact Info</Heading>
            </TitleContainer>

            <DescriptionContainer>
              <TabContainer>
                <IconContainer>
                  <ImLocation />
                </IconContainer>
                <SubHeading>13 Pipe line, Winnipeg Manitoba, Canada.</SubHeading>
              </TabContainer>

              <TabContainer>
                <IconContainer>
                  <GiRotaryPhone />
                </IconContainer>
                <SubHeading> +1 (431) 335-3993 </SubHeading>
              </TabContainer>

              <TabContainer>
                <IconContainer>
                  <MdPhoneIphone />
                </IconContainer>
                <SubHeading> +1 (431) 335-3993 </SubHeading>
              </TabContainer>

              <TabContainer>
                <IconContainer>
                  <MdEmail />
                </IconContainer>
                <SubHeading>gagansahi@singhdrywall.com</SubHeading>
              </TabContainer>

              <TabContainer>
                <IconContainer>
                  <GiEarthAsiaOceania />
                </IconContainer>
                <SubHeading>singhdrywall.com</SubHeading>
              </TabContainer>
            </DescriptionContainer>
          </RightContainer>
        </FlexContainer>
        <TopContainer>
          <Heading>General Enquiry</Heading>
          <form ref={form} onSubmit={sendEmail}>
            <FormContainer>
              <Input type="text" name="user_name" placeholder="Name" />
              <Input type="text" name="user_email" placeholder="*Email" required />
            </FormContainer>

            <FormContainer>
              <Input type="text" name="phone_number" placeholder="*Phone" required />
              <Input type="text" name="subject" placeholder="Subject" />
            </FormContainer>

            <FormContainer>
              <MessageInput type="text" name="message" placeholder="Message" />
            </FormContainer>
            <SubmitButtonContainer>
              <SubmitButton />
            </SubmitButtonContainer>
          </form>
        </TopContainer>
      </Container>
    </>
  );
};
